import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full min-h-[70vh] flex flex-col items-center justify-center text-center px-4 pt-24 pb-16">
      <p className="font-label text-7xl md:text-9xl text-primary-500/30 font-bold select-none">404</p>
      <h1 className="mt-2 font-heading text-xl md:text-2xl text-foreground-950 font-bold">
        这个页面还没有被生成
      </h1>
      <p className="mt-3 text-sm text-foreground-500 font-mono break-all max-w-md">{location.pathname}</p>
      <p className="mt-2 text-sm text-foreground-600">你可以返回首页，或从分类页重新开始浏览。</p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-foreground-950 text-sm rounded-md px-6 py-3 whitespace-nowrap cursor-pointer transition-colors"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center gap-2 bg-background-100 border border-background-300/60 hover:border-primary-400/60 text-foreground-900 text-sm rounded-md px-6 py-3 whitespace-nowrap cursor-pointer transition-colors"
        >
          <i className="ri-stack-line" />
          浏览分类
        </Link>
      </div>
    </div>
  );
}